import { useEffect, useState } from "react";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";
import Spinnerr from "../Commaon/Spinner";
import Toaster from "../Commaon/Toaster";
import { CgTrash } from "react-icons/cg";
import { Modal } from "react-bootstrap";
import CustomModal from "../Commaon/CustomModal";

const BlockSlotList = () => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState(null);

  // pagination states
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);

  // add / delete modals
  const [addSlots, setAddSlots] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  // add slot states
  const [blockDate, setBlockDate] = useState("");
  const [blockSlotId, setBlockSlotId] = useState("");
  const [blockReason, setBlockReason] = useState("");

  const getSlots = async () => {
    setLoading(true);
    try {
      const response = await AuthInterceptor(`/admin/block-slot`, {
        method: "GET",
      });
      const data = response.data;
      if (data.s === 200) setSlots(data.r || []);
    } catch (err) {
      console.error("Failed to fetch slots:", err);
      setSnack({
        notification: { message: "Error fetching slots", type: "error" },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSlots();
  }, []);

  // add block slot
  const handleAddSlot = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthInterceptor(`/admin/block-slot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          date: blockDate,
          slotId: blockSlotId,
          reason: "Not Available",
        }),
      });

      const data = response.data;
      if (data.s === 201) {
        setSlots((prev) => [...prev, data.r]);
        setSnack({
          notification: {
            message: "Slot blocked successfully",
            type: "success",
          },
        });
      }else {
        setSnack({
          notification: { message: data.m || "Error blocking slot", type: "error" },
        });
      }
    } catch (err) {
      console.error("Error blocking slot:", err);
      setSnack({
        notification: { message: "Error blocking slot", type: "error" },
      });
    } finally {
      setLoading(false);
      setAddSlots(false);
      setBlockDate("");
      setBlockSlotId("");
    }
  };

  // delete confirm setup
  const deleteSlot = async (id) => {
    setConfirmDeleteId(id);
    setShowDeleteConfirm(true);
  };

  // pagination slice
  const startIndex = (pageNo - 1) * limit;
  const paginatedSlots = slots.slice(startIndex, startIndex + limit);

  return (
    <>
      {loading && <Spinnerr show={loading} />}
      {snack && (
        <Toaster
          notification={snack.notification}
          onClose={() => setSnack(null)}
        />
      )}

      <div className="card shadow-sm border-0 rounded-3 p-3">
        {/* Header + Page Size */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mr-3 gap-3">
          <h2 className="mb-2 mb-md-0">Blocked Slots</h2>
          <div className="d-flex flex-row align-items-center gap-3">
            <button
              className="btn btn-sm btn-outline-custom text-nowrap"
              onClick={() => setAddSlots(true)}
              disabled={loading}
            >
              Block Slot
            </button>
            <select
              className="form-select form-select-sm"
              value={limit}
              onChange={(e) => {
                setPageNo(1);
                setLimit(Number(e.target.value));
              }}
            >
              {[5, 10, 20, 50].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive">
           <table className="table table-hover align-middle" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead className="table-light">
              <tr>
                <th>Sr.</th>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Status</th>
                <th style={{ width: "150px" }} className="text-start">Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSlots.length > 0 ? (
                paginatedSlots.map((slot, idx) => (
                  <tr key={slot._id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{slot.date || "-"}</td>
                    <td>{slot.startTime || "-"}</td>
                    <td>{slot.endTime || "-"}</td>
                    <td>
                      <span
                        role="button"
                        className={`badge ${
                          slot.isActive ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {slot.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex justify-content-start gap-3 fs-5">
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => deleteSlot(slot._id)}
                        >
                          <CgTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-4">
                    No blocked slots found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex flex-wrap justify-content-between align-items-center m-3 gap-2">
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
            disabled={pageNo === 1}
          >
            Prev
          </button>
          <span className="mx-2">
            Page {pageNo} of {Math.ceil(slots.length / limit) || 1}
          </span>
          <button
            className="btn btn-outline-custom btn-sm"
            onClick={() =>
              setPageNo((prev) =>
                prev < Math.ceil(slots.length / limit) ? prev + 1 : prev
              )
            }
            disabled={pageNo >= Math.ceil(slots.length / limit)}
          >
            Next
          </button>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <CustomModal
        show={showDeleteConfirm}
        title="Confirm Deletion"
        message="Are you sure you want to unblock this slot?"
        onConfirm={async () => {
          try {
            setLoading(true);
            const response = await AuthInterceptor(
              `/admin/block-slot/${confirmDeleteId}`,
              { method: "DELETE" }
            );
            const data = response.data;
            if (data.s === 200) {
              setSlots((prev) =>
                prev.filter((slot) => slot._id !== confirmDeleteId)
              );
              setSnack({
                notification: {
                  message: "Slot unblocked successfully",
                  type: "success",
                },
              });
            }
          } catch (err) {
            console.error("Error deleting slot:", err);
            setSnack({
              notification: { message: "Error deleting slot", type: "error" },
            });
          } finally {
            setLoading(false);
            setShowDeleteConfirm(false);
            setConfirmDeleteId(null);
          }
        }}
        onCancel={() => {
          setShowDeleteConfirm(false);
          setConfirmDeleteId(null);
        }}
      />

      {/* Add Block Slot Modal */}
      <Modal show={addSlots} onHide={() => setAddSlots(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Block Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddSlot}>
            <div className="mb-3">
              <label className="form-label">Date</label>
              <input
                type="date"
                className="form-control"
                value={blockDate}
                onChange={(e) => setBlockDate(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Slot ID</label>
              <input
                type="text"
                className="form-control"
                value={blockSlotId}
                onChange={(e) => setBlockSlotId(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Reason</label>
              <input
                type="text"
                className="form-control"
                value={blockReason}
                onChange={(e) => setBlockReason(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <Spinnerr show={loading} /> : "Block Slot"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BlockSlotList;
